<template>
  <div
    v-if="maxlength"
    class="s-character-counter"
    :class="{
      's-character-counter--overflow-attempted': overflowAttempted,
      's-character-counter--disabled': disabled,
    }"
  >
    {{ length }}/{{ maxlength }}
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
  disabled?: boolean;
  maxlength?: number;
  modelValue?: string | null;
  overflowAttempted?: boolean;
}>();

const length = computed(() => props.modelValue?.length ?? 0);
</script>

<style lang="postcss">
.s-character-counter {
  @apply text-xs leading-6 text-slate-700;

  &--overflow-attempted {
    @apply text-red-500;
  }

  &--disabled {
    @apply text-slate-500;
  }
}
</style>
